<template>
  <footer id="footer">
    <div class="footer seasidetms_color_scheme_footer seasidetms_footer_small">
      <div class="footer_inner">
        <div class="social_wrap" style="display: none">
          <div class="social_wrap_inner">
            <ul>
              <li>
                <a
                  href="#"
                  class="seasidetms_social_icon seasidetms_social_icon_1 seasidetms-icon-gplus-1 seasidetms_social_icon_color"
                  title="Google+"
                  target="_blank"
                ></a>
              </li>
            </ul>
          </div>
        </div>
        <div
          style="
            text-align: center;
            padding-bottom: 23px;
            display: flex;
            justify-content: center;
          "
        >
          <!-- <img src="/img/liqpayfooter2.png" class="mc-visa-footer pay" style="max-height: 45px"> -->
          <img src="/img/platon-logo.png" class="platon-footer pay" />
          <img src="/img/visa-logo.png" class="visa-footer pay" />
          <img src="/img/mc-logo.svg" class="mc-footer pay" />
          <img
            src="/img/vb-visa-logo.png"
            class="vb-visa-footer pay white-bg"
          />
          <img src="/img/mc-mp-logo.png" class="mc-mp-footer pay white-bg" />
          <img
            src="/img/mc-secure-code.png"
            class="mc-secure-footer pay white-bg"
          />
          <img src="/img/ap-logo.svg" class="ap-footer pay white-bg" />
          <img src="/img/gp-logo.svg" class="gp-footer pay white-bg" />
          <img src="/img/p24-logo.svg" class="p24-footer pay white-bg" />
        </div>
        <span class="footer_copyright copyright">
          <router-link
            class="privacy-policy-link"
            :to="getPath('privacy-policy')"
          >
            {{ $t('mainMenu.privacypolicy') }}
          </router-link>
          /
          <router-link :to="getPath('legal')">
            {{ $t('mainMenu.legal') }}
          </router-link>
          / AppTown. &copy; 2019-{{ year }} / {{ $t('allRightsReserved') }}
        </span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  computed: {
    year() {
      const d = new Date()
      return d.getFullYear()
    },
  },
  data() {
    return {
      lang: '',
    }
  },
  methods: {
    getPath(slug) {
      return `${this.lang ? `/${this.lang}` : ''}/${slug}`
    },
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
.pay {
  max-height: 30px;
  padding: 2px;
  margin: 5px;
  border-radius: 3px;
}

.white-bg {
  background-color: #ffffff;
}
</style>
